// Matches the `Category` value the API sets on a report's config entry
// (appsettings) for reports that belong on the CPG landing page (`/bi/cpg`)
// instead of getting an individual tile on the main BI reports hub.
export const CPG_REPORT_CATEGORY = 'CPG';
